import {
  InputFieldProps,
  InputItem,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React, { useState } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  UseFormRegister,
} from 'react-hook-form';

interface ToggleButtonProps<T extends FieldValues> extends InputFieldProps<T> {
  onValue: string;
  offValue: string;
  register: UseFormRegister<T>;
  children?: React.ReactNode;
  defaultValue?: boolean;
  disabled?: boolean;
  control: Control<T, object>;
}

export const ToggleButton = <T extends FieldValues>({
  title,
  inputKey,
  className,
  register,
  children,
  onValue,
  offValue,
  defaultValue = false,
  disabled = false,
  control,
}: ToggleButtonProps<T>) => {
  const [isToggleActive, setIsToggleActive] = useState(defaultValue);
  const toggleValue = React.useCallback(
    (formCallback: (isToggleActive: boolean) => void) => {
      formCallback(!isToggleActive);
      setIsToggleActive(!isToggleActive);
    },
    [setIsToggleActive, isToggleActive]
  );

  return (
    <InputItem className={className} title={title}>
      <div className="flex flex-row items-center">
        <Controller
          control={control}
          name={inputKey}
          render={({ field: { onChange, ref } }) => (
            <button
              className={`${isToggleActive ? 'bg-brand-blue' : 'bg-gray-400'} ${
                disabled ? 'cursor-auto' : 'cursor-pointer'
              } w-9 h-4.5 flex flex-row items-center rounded-lg`}
              onClick={disabled ? undefined : () => toggleValue(onChange)}
              ref={ref}
              type="button"
            >
              <input
                checked={false}
                className={`${isToggleActive ? 'ml-5' : ''} ${
                  disabled ? 'cursor-auto' : 'cursor-pointer'
                } rounded-full focus:ring-transparent toggle-checkbox`}
                disabled={disabled}
                onClick={() => toggleValue(onChange)}
                readOnly={true}
                {...register}
                ref={ref}
                type="checkbox"
              />
            </button>
          )}
        />
        <label className="ml-3 text-sm w-14">
          {isToggleActive ? onValue : offValue}
        </label>
        {children}
      </div>
    </InputItem>
  );
};
